import { api } from './api';

// Personal settings that follow you to every device: kept on your profile on the server, with a
// copy in this browser so they apply instantly (and still work offline).

export type PrefKey = 'transport' | 'shareQuality' | 'shareMode' | 'chatSound' | 'mode';
const LOCAL: Record<PrefKey, string> = { transport: 'vb.transport', shareQuality: 'vb.shareQuality', shareMode: 'vb.shareMode', chatSound: 'vb.chatSound', mode: 'vb.mode' };

export function readPref(k: PrefKey): string | null {
  try {
    return localStorage.getItem(LOCAL[k]);
  } catch {
    return null;
  }
}

function writeLocal(k: PrefKey, v: string) {
  try {
    localStorage.setItem(LOCAL[k], v);
  } catch {
    /* private mode */
  }
}

/** Save on this device and on the profile. */
export function savePref(k: PrefKey, v: string) {
  writeLocal(k, v);
  api.updateProfile({ prefs: { [k]: v } }).catch(() => undefined);
}

/** On sign-in: the profile's settings win over whatever this device had. */
export function adoptPrefs(prefs: Partial<Record<PrefKey, string>> | undefined) {
  for (const [k, v] of Object.entries(prefs ?? {})) if (v && k in LOCAL) writeLocal(k as PrefKey, v);
}
